/** @file tileMirrorX: the column a pixel column mirrors to across the pivot column of a tile. */

/**
 * The mirror of column `x` in a tile `width` wide whose pivot sits at `pivotX` pixels from the left edge
 * (`pivotFrac[0] * width`). Rule: when `pivotX` falls inside a pixel, that pixel's column `c = floor(pivotX)` maps to
 * itself and `x` mirrors to `2c - x`; when `pivotX` is a whole number (the pivot on the line between two columns,
 * e.g. an even width with `pivotFrac.x` 0.5) columns pair across that line: `x` mirrors to `2 * pivotX - 1 - x`, so
 * `w/2 - 1 - k` and `w/2 + k` swap. Null when the mirrored column falls outside the tile.
 */
export function tileMirrorX(x: number, width: number, pivotX: number): number | null {
  const m = Number.isInteger(pivotX) ? 2 * pivotX - 1 - x : 2 * Math.floor(pivotX) - x;
  return m >= 0 && m < width ? m : null;
}
